module.exports = __webpack_public_path__ + "static/media/anets_logo.3e4aba6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/anets_logo.png
// module id = 2224
// module chunks = 0